export const toQueryString = (obj) => {
  const parts = [];
  for (const i in obj) {
    const property = obj[i];
    if (obj.hasOwnProperty(i) && property && encodeURIComponent(property).length) {
      if (property instanceof Array) {
        for (let j = 0; j < property.length; j++) {
          parts.push(`${encodeURIComponent(i)}[]=${encodeURIComponent(property[j])}`);
        }
      } else {
        parts.push(`${encodeURIComponent(i)}=${encodeURIComponent(obj[i])}`);
      }
    }
  }
  return parts.join('&');
};
